import { SuperAdminStatusEnum } from "props/enum";

/**
 * Permission actions of every role the user holds, as a flat list.
 * Menus and action buttons match against this list.
 */
export const flattenRoleActions = (roles: any[]): string[] =>
  (roles ?? [])
    .flatMap((role: any) =>
      (role?.permissions ?? []).map((permission: any) => permission?.action?.action)
    )
    .filter(Boolean);

export const roleNames = (roles: any[]): string[] =>
  (roles ?? []).map((role: any) => role?.name).filter(Boolean);

/**
 * A user can hold several roles, so the super admin one is not necessarily
 * the first — pick it when present, otherwise fall back to the first role.
 */
export const resolveSuperAdmin = (names: string[]): string | null => {
  const cleaned = (names ?? []).filter(Boolean);
  return (
    cleaned.find(
      (name: string) => name?.toLowerCase() === SuperAdminStatusEnum.SuperAdmin
    ) ??
    cleaned[0] ??
    null
  );
};

/** Actions were stored per role at one point, so accept both shapes. */
export const normalizeStoredActions = (parsed: any): string[] =>
  Array.isArray(parsed) ? parsed.flat(Infinity).filter(Boolean) : [];

export const normalizeStoredSuperAdmin = (parsed: any): string | null =>
  Array.isArray(parsed) ? resolveSuperAdmin(parsed) : parsed ?? null;
